import { createContext, useContext } from "react";

const MIAMI = {
  location: "miami",
  name: "Miami",
  locationLabel: "Miami, FL",
  bgBase: "#F5F5F5",
  bgSurface: "#FFFFFF",
  primary: "#CC2222",
  secondary: "#2C2C2C",
  text: "#1A1A1A",
  navBg: "#0A0A0A",
  navText: "#FFFFFF",
  btnPrimary: "bg-[#CC2222] text-white hover:bg-[#a81b1b] transition-colors",
  btnOutline: "border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors",
  accentBorder: "border-[#E5E5E5]",
  themeClass: "theme-miami",
};

const ThemeContext = createContext(MIAMI);

export function ThemeProvider({ children }) {
  return <ThemeContext.Provider value={MIAMI}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
